import dayjs from "dayjs";
import { shortMonthAndShortYear } from "@similarweb/pro-logic-components";

export const transformHistoricalData = (rawData) => {
    if (!rawData) {return null;}

    return {
        Data: Object.entries(rawData).map(([date, data]: [string, object]) => {
            return {
                date: dayjs(date).format(shortMonthAndShortYear),
                ...data,
            };
        }),
    };
};
